const keyPrefix = 'intervox';

export const KEYS = {
  AUTH_TOKEN: 'AUTH_TOKEN',
  CLIENT: 'CLIENT',
  EXPIRY: 'EXPIRY',
  UID: 'UID',
  TOKEN_TYPE: 'TOKEN_TYPE',
  LIST_VIEW: 'LIST_VIEW',
};

export const getItem = key => localStorage.getItem(`${keyPrefix}:${key}`);

export const setItem = (key, value) =>
  localStorage.setItem(`${keyPrefix}:${key}`, value);

export const removeItem = key => localStorage.removeItem(`${keyPrefix}:${key}`);

export const clear = () => {
  const lsKeys = Object.keys(localStorage);
  lsKeys.forEach(key => {
    if (key.indexOf(keyPrefix) !== -1) {
      localStorage.removeItem(key);
    }
  });
};
